<template>
    <el-card>
        <p slot="header">
            {{warehouse.name}}
        </p>
        <el-button size="small" @click="init()" slot="extra" type="primary" shape="circle" icon="ios-refresh" :loading="refreshLoading"></el-button>
        <el-row :gutter="16">
            <el-col :span="12">
                <el-divider orientation="center">今日数据</el-divider>
                <ul class="tinfo">
                    <li>出库订单：{{wh.todayDatas.todayOutgoing}}</li>
                    <li>新增订单：{{wh.todayDatas.todayCreate}}</li>
                    <li>签收包裹：{{wh.todayDatas.todaySign}}</li>
                    <li>新增包裹：{{wh.todayDatas.todayPackageCreate}}</li>
                </ul>
            </el-col>
            <el-col :span="12">
                <el-divider orientation="center">累计数据统计</el-divider>
                <ul class="tinfo">
                    <li>待出库订单：{{wh.allDatas.toOutgoingCount}}</li>
                    <li>待签收订单：{{wh.allDatas.toSignCount}}</li>
                    <li>待签收包裹：{{wh.allDatas.toPackageSignCount}}</li>
                </ul>
            </el-col>
        </el-row>
    </el-card>
</template>
<script>
import Constants from '@/utils/constants'
export default {
    name: "Index",
    data() {
        return {
            wh: {
                name: "",
                allDatas: {
                    toOutgoingCount: 0,
                    toSignCount: 0,
                    toPackageSignCount: 0
                },
                todayDatas: {}
            },
            refreshLoading: false
        }
    },
    props: [
        "warehouse"
    ],
    mounted: function() {
        this.init();

    },
    methods: {
        init() {
            this.getWhIndex();
            this.getToday();
        },
        getWhIndex() {
            var me = this;
            me.refreshLoading = true;
            me.$http.post("/ware/stastis/index.action", { warehouseId: me.warehouse.id }).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.wh.allDatas = body.obj;
                }
                me.refreshLoading = false;
            }, response => {
                me.refreshLoading = false;
            });
        },
        getToday: function() {
            var me = this;
            // me.refreshLoading = true;
            me.$http.post("/ware/stastis/today.action", {
                warehouseId: me.warehouse.id
            }).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.wh.todayDatas = body.obj;
                }
                // me.refreshLoading = false;
            }, response => {
                // me.refreshLoading = false;
            });
        },
    }
}
</script>
<style>
.tinfo {

    display: inline-block;
}

.tinfo li {
    list-style: none;
    line-height: 2;
    font-size: 16px;
}

.dawar {
    display: table;
    width: 100%;
}

.dawar>div {
    display: table-cell;
    width: 50%;
}
</style>